import * as React from 'react';

import { Redirect, Route } from 'react-router-dom';

import { connect } from 'react-redux';
import { IRootState } from '../../redux/Reducers/RootReducer';

import Api from '../Api';

function mapStateToProps(state: IRootState, ownProps: any) {
  return { security: state.securityState.security };
}

function SecuredRoute(props: any) {
  const { component: Component, ...others } = props;
  return (
    <Route
      {...others}
      // tslint:disable-next-line:jsx-no-lambda
      render={() => {
        if (props.security && props.security.token) {
          Api.defaults.headers.common.Authorization = props.security.token;

          return <Component />;
        } else {
          return (
            <Redirect
              to={{
                pathname: '/login',
                search: 'goTo=' + encodeURIComponent(props.location.pathname + props.location.search)
              }}
            />
          );
        }
      }}
    />
  );
}

export default connect(mapStateToProps)(SecuredRoute);
